<template>
    <div>
        <div class="d-flex-between mt-5">
            <div class="header">
                {{ $vuetify.lang.t('$vuetify.report.report') }}
            </div>
            <div v-if="!this.isReportAcp">
                <v-autocomplete
                    v-model="branchSeleted"
                    :items="branches"
                    solo
                    item-text="name"
                    item-value="id"
                    label="Branch">
                </v-autocomplete>
            </div>
        </div>
        <nav-bar
            ref="navbar"
            v-model="navBarComponent"
            @menu-change="menuChange"
            :menuItem="navbarList">
        </nav-bar>
        <v-card class="content-container">
            <div class="report-container">
                <v-container>
                    <v-radio-group v-if="this.attendancReport" v-model="selectedReport" row>
                        <v-radio
                            v-for="(reportType, reportTypeIndex) in reportTypes"
                            :key="reportTypeIndex"
                            :label="reportType.text"
                            :value="reportType.value"
                            class="locale-font"
                        ></v-radio>
                    </v-radio-group>
                    <v-radio-group v-if="!this.attendancReport" v-model="selectedReport" row>
                        <v-radio
                            v-for="(reportVisitorType, reportVisitorTypeIndex) in reportVisitorTypes"
                            :key="reportVisitorTypeIndex"
                            :label="reportVisitorType.text"
                            :value="reportVisitorType.value"
                            class="locale-font"
                        ></v-radio>
                    </v-radio-group>
                    <component
                        :is="component"
                        :branchId="branchSeleted"
                        :canGenReport="canGenReport" />
                </v-container>
            </div>
        </v-card>
    </div>
</template>

<script>
import Daily from '@/components/report/Daily'
import Weekly from '@/components/report/Weekly'
import Monthly from '@/components/report/Monthly'
import Quarterly from '@/components/report/Quarterly'
import VisitorDaily from '@/components/report/VisitorDaily.vue'
import EmployeeMonthlyLog from '@/components/report/EmployeeMonthlyLog.vue'
import BranchOverviewReport from '@/components/report/BranchOverviewReport.vue'
import NavBar from '@/components/NavBar.vue'
export default {
    name: 'Report',

    components: {
        Daily,
        Weekly,
        Monthly,
        Quarterly,
        VisitorDaily,
        EmployeeMonthlyLog,
        BranchOverviewReport,
        NavBar
    },

    computed: {
        canGenReport () {
            if (localStorage.getItem('currentBranchId')) {
                return true
            }
            return false
        },

        reportTypes () {
            const menus = [
                {
                    text: this.$vuetify.lang.t('$vuetify.report.dailyReport'),
                    value: 'Daily'
                }, {
                    text: this.$vuetify.lang.t('$vuetify.report.monthlyReport'),
                    value: 'Monthly'
                }, {
                    text: this.$vuetify.lang.t('$vuetify.report.empMonthlyLogReport'),
                    value: 'EmployeeMonthlyLog'
                }
            ]

            if (process.env.VUE_APP_KC_REPORT === 'true') {
                menus.push({
                    text: this.$vuetify.lang.t('$vuetify.report.branchOverviewReport'),
                    value: 'BranchOverviewReport'
                })
            }

            return menus
        },

        reportVisitorTypes () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.report.dailyReport'),
                    value: 'VisitorDaily'
                }
            ]
        },

        allBranch () {
            return {
                name: this.$vuetify.lang.t('$vuetify.report.allBranch'),
                id: 0
            }
        },

        branches () {
            const branchesList = this.$store.state.branches.slice(0)
            if (branchesList) {
                if (!this.isReportAcp) {
                    branchesList.unshift(this.allBranch)
                }
            }
            return branchesList
        },

        menuItem () {
            return [
                {
                    title: this.$vuetify.lang.t('$vuetify.report.attendanceReport'),
                    path: 'Daily',
                    pathName: 'daily',
                    permission: [
                        //
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.report.visitorReport'),
                    path: 'VisitorDaily',
                    pathName: 'visitor-report-daily',
                    permission: [
                        //
                    ]
                }
            ]
        },

        navbarList () {
            const navbar = []
            for (let i = 0; i < this.menuItem.length; i++) {
                // const show = this.menuItem[i].permission.some(p => this.userPermissions.includes(p))
                // if (show) {
                navbar.push(this.menuItem[i])
                // }
            }
            return navbar
        }
    },

    data () {
        return {
            selectedReport: 'Daily',
            navBarComponent: '',
            attendancReport: true,
            error: null,
            component: 'Daily',
            branchSeleted: 0,
            isReportAcp: ''
        }
    },

    methods: {
        menuChange (payload) {
            this.component = payload.path
            if (payload.path === 'Daily') {
                this.attendancReport = true
                this.selectedReport = 'Daily'
            } else {
                this.attendancReport = false
                this.selectedReport = 'VisitorDaily'
            }
            const path = `/report/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        setDefaultPath () {
            this.component = this.navbarList[0].path
        },

        setActive (path) {
            let index = 0
            if (path === 'Report') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            const directPath = `/report/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.isReportAcp = process.env.VUE_APP_REPORT === 'ACP'
        if (this.isReportAcp) {
            // remove Monthly option for acp
            this.reportTypes.pop(1)
        }
        if (this.branches) {
            if (!this.isReportAcp) {
                this.branches.unshift(this.allBranch)
                this.branchSeleted = 0
            } else {
                this.branchSeleted = parseInt(localStorage.getItem('currentBranchId'))
            }

            this.setDefaultPath()
            this.setActive(this.$router.currentRoute.name)
        }
    },

    watch: {
        selectedReport (newValue) {
            this.component = newValue
        }
    }
}
</script>

<style lang="scss" scoped>
.sub-header {
    padding: 16px;
    display: flex;
    justify-content: flex-end;
}
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}
.dropdown-size {
    width: 200px;
}
.content-container {
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: 15px !important;
}
.report-container {
    padding: 1rem;
}
.nav-bar {
    padding-bottom: 40px;
}
</style>
